/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrtooldescription2Inputs */

const en_qrtooldescription2 = /** @type {(inputs: Qrtooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a branded QR code with an optional logo.`)
};

const de_qrtooldescription2 = /** @type {(inputs: Qrtooldescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen QR-Code im Marken-Look mit optionalem Logo erstellen.`)
};

/**
* | output |
* | --- |
* | "Create a branded QR code with an optional logo." |
*
* @param {Qrtooldescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrtooldescription2 = /** @type {((inputs?: Qrtooldescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrtooldescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrtooldescription2(inputs)
	return de_qrtooldescription2(inputs)
});
export { qrtooldescription2 as "qrToolDescription" }